
export const ROUTE_ID = '/onboarding'


